import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import Dialog from '@material-ui/core/Dialog';
import LinearProgress from '../../../Utils/LinearProgress';
import RUDiscountModal from './RUDiscountModal';
import UsedRentalsSubLotLPGainAPI from '../../../../API/UsedRentalsSubLotLPGainAPI';
import ConfirmationDialog from '../../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { handleServerError } from '../../../../Utils/Helper';
import { UR_CREATION_GROUP, NEGOTIATION_PHASE } from '../../../../Utils/Constants';


const headerData = [
  { id: 'sublotLPgain', label: 'CÓDIGO / DESCRIÇÃO' },
  { id: 'value', label: 'VALOR' },
  { id: 'sublotLPgainObs', label: 'OBSERVAÇÕES' },
];

const styles = theme => ({
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorderHead: {
    border: '2px solid #ffffff'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  tableWrapper: {
    overflowX: 'auto',
    padding: 0
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  valueWidth: {
    width: '76px'
  },
  iconsWidth: {
    width: '86px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  alignIcons: {
    display: 'flex',
    marginLeft: '13px'
  }
});


class RUDiscountTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      newEditButton: false,
      openDialog: false,
      loading: false,
      success: false,
      deleteL2LPGainId: '',
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      data: [],
      openError: false,
      alertMessage: ''
    };
  }

  componentDidMount() {
    this.reloadTable();
  };

  reloadTable() {
    const tableDataAPI = new UsedRentalsSubLotLPGainAPI();
    if (this.props.L1ID > 0) {
      this.setState({ loading: true });
      tableDataAPI.getSubLotLPGainByL2Id(this.props.L2ID).then((response) => {
        this.setState({
          data: response.data.ResultList,
          loading: false
        });
      }).catch((error) => {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      });
    }
  };

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  }

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleClickDelete = (subLotId, gainId) => {
    this.setState({
      openDialog: true,
      deleteSubLotId: subLotId,
      deleteGainId: gainId,
      confirmationQuestion: 'Tem a certeza que pretende ELIMINAR a linha de Ganho LP?',
      confirmationMessage: 'A informação relativamente ao Ganho LP associado ao sublote será eliminada e não poderá ser recuperada.',
      confirmationFunction: this.handleSubmitDelete,
      cancelFunction: this.handleCloseDialog
    });
  };

  handleSubmitDelete = () => {
    const Negotiation_API = new UsedRentalsSubLotLPGainAPI();
    this.setState({ loading: true })
    Negotiation_API.deleteSubLotLPGain(this.state.deleteSubLotId, this.state.deleteGainId).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.setState({
          success: false,
        });
        this.handleCloseDialog();
        this.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog()
    });
  };

  deleteButtonRenderer = (subLotId, gainId) => {
    const { classes } = this.props;
    return (
      <Tooltip title='Eliminar' placement='bottom' >
        <IconButton aria-label='Delete' onClick={() => { this.handleClickDelete(subLotId, gainId) }} className={classes.buttonSizeTbl} >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    );
  }

  renderTableHeader() {
    const { classes } = this.props;

    return (
      <TableRow className={classes.headerHeight} >
        {headerData.map(column => {
          return (
            <TableCell key={column.id} padding='none' className={classNames(classes.tblHeadT, classes.tblBorderHead, classes.textCenter)}>
              {column.label}
            </TableCell>
          );
        }, this)}
        {this.props.estadoId === NEGOTIATION_PHASE && this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) > -1 ?
          <TableCell className={classNames(classes.tblBorderHead, classes.textCenter)} padding='none'>
            <RUDiscountModal estadoId={this.props.estadoId} L2ID={this.props.L2ID} L1ID={this.props.L1ID} reloadTable={this.reloadTable.bind(this)} newEditButton={true} lpGainData={this.props.lpGainData} />
          </TableCell>
          :
          null
        }
      </TableRow>
    );
  }

  renderTableRecords(subLotLPGainList) {
    const { classes } = this.props;
    const subLotLPGain = subLotLPGainList.map(subLotLPGainItem => {
      return (
        <TableRow key={subLotLPGainItem.SubLotLPGainId} tabIndex={-1} className={classes.tblRow}>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {subLotLPGainItem.LPGain}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.valueWidth)} component='th' scope='row' padding='none'>
            {subLotLPGainItem.Value + '€'}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {subLotLPGainItem.SubLotLPGainObservations}
          </TableCell>
          {this.props.estadoId === NEGOTIATION_PHASE && this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) > -1 ?
            <TableCell className={classNames(classes.tblBorder, classes.iconsWidth)} padding='none'>
              <div className={classes.alignIcons}>
                <RUDiscountModal estadoId={this.props.estadoId} L1ID={this.props.L1ID} sublotLPGainData={subLotLPGainItem} L2ID={this.props.L2ID} reloadTable={this.reloadTable.bind(this)} newEditButton={false} lpGainData={this.props.lpGainData} />
                {this.deleteButtonRenderer(subLotLPGainItem.L2Id, subLotLPGainItem.LPGainId)}
              </div>
            </TableCell>
            :
            null
          }
        </TableRow>
      );
    })
    return subLotLPGain;
  }


  render() {
    const { classes } = this.props;
    const { loading } = this.state;

    return (
      <Paper className={classes.tableWrapper}>

        <Table>
          <TableHead className={classes.tblHead}>
            {this.renderTableHeader()}
          </TableHead>
          <TableBody>
            {this.renderTableRecords(this.state.data)}
          </TableBody>
        </Table>

        {loading && <LinearProgress />}

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleCloseDialog.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

RUDiscountTable.propTypes = {
  classes: PropTypes.object.isRequired,
  L1ID: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(RUDiscountTable));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsCreation/UsedRentalsDiscounts/RUDiscountTable.js